// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ===============================
   PREMIUM PARTNERS SECTION - HEXAGONAL LAYOUT
=============================== */

.partners-section {
    padding: 120px 0;
    position: relative;
    overflow: hidden;
}

/* ===============================
   SECTION HEADER
=============================== */

.section-header {
    text-align: center;
    margin-bottom: 100px;
    animation: fadeInUp 0.8s ease-out;
}

.section-badge {
    display: inline-block;
    padding: 8px 20px;
    background: rgba(99, 102, 241, 0.15);
    border: 1px solid rgba(139, 92, 246, 0.4);
    border-radius: 50px;
    color: rgba(255, 255, 255, 0.95);
    font-size: 0.875rem;
    font-weight: 600;
    margin-bottom: 24px;
    text-transform: uppercase;
    letter-spacing: 0.05em;
    box-shadow: 0 4px 20px rgba(99, 102, 241, 0.2);
}

.section-title {
    font-size: clamp(2rem, 4vw, 3.5rem);
    font-weight: 700;
    color: #ffffff;
    margin-bottom: 16px;
    letter-spacing: -0.02em;
    line-height: 1.2;
}

.gradient-text {
    background: linear-gradient(135deg, #818cf8, #c084fc, #f472b6);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
}

.section-subtitle {
    font-size: 1.125rem;
    color: rgba(255, 255, 255, 0.75);
    font-weight: 500;
}

@keyframes fadeInUp {
    from {
        opacity: 0;
        transform: translateY(20px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
}

/* ===============================
   PARTNERS GRID - HEXAGONAL
=============================== */

.partners-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
    gap: 35px;
    max-width: 1100px;
    margin: 0 auto;
}

/* ===============================
   PARTNER CARD - HEXAGONAL SHAPE
=============================== */

.partner-card {
    position: relative;
    background: linear-gradient(135deg, rgba(99, 102, 241, 0.08), rgba(168, 85, 247, 0.05));
    border: 2px solid rgba(139, 92, 246, 0.3);
    padding: 50px 36px;
    text-align: center;
    transition: all 0.5s cubic-bezier(0.16, 1, 0.3, 1);
    cursor: pointer;
    overflow: hidden;
    animation: fadeInUp 0.6s ease-out both;
    clip-path: polygon(
        30% 0%, 70% 0%,
        100% 30%, 100% 70%,
        70% 100%, 30% 100%,
        0% 70%, 0% 30%
    );
}

.partner-card[data-index="0"] { animation-delay: 0.1s; }
.partner-card[data-index="1"] { animation-delay: 0.2s; }
.partner-card[data-index="2"] { animation-delay: 0.3s; }
.partner-card[data-index="3"] { animation-delay: 0.4s; }
.partner-card[data-index="4"] { animation-delay: 0.5s; }
.partner-card[data-index="5"] { animation-delay: 0.6s; }

/* Gradient border effect */
.partner-card::before {
    content: '';
    position: absolute;
    inset: 0;
    background: linear-gradient(135deg, rgba(99, 102, 241, 0.3), rgba(168, 85, 247, 0.2));
    opacity: 0;
    transition: opacity 0.5s ease;
}

.partner-card:hover::before {
    opacity: 1;
}

.partner-card:hover {
    transform: translateY(-12px) scale(1.05);
    border-color: rgba(168, 85, 247, 0.6);
    box-shadow: 
        0 25px 60px rgba(99, 102, 241, 0.4),
        0 0 60px rgba(168, 85, 247, 0.3);
}

/* ===============================
   LOGO
=============================== */

.partner-logo-wrapper {
    width: 130px;
    height: 130px;
    margin: 0 auto 28px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(99, 102, 241, 0.1);
    border-radius: 50%;
    transition: all 0.5s cubic-bezier(0.16, 1, 0.3, 1);
    position: relative;
    z-index: 2;
    border: 2px solid rgba(139, 92, 246, 0.3);
}

.partner-logo {
    width: 75px;
    height: 75px;
    object-fit: contain;
    filter: brightness(0) invert(1);
    opacity: 0.85;
    transition: all 0.5s ease;
}

.partner-card:hover .partner-logo-wrapper {
    background: rgba(168, 85, 247, 0.2);
    transform: scale(1.1) rotate(15deg);
    border-color: rgba(168, 85, 247, 0.6);
}

.partner-card:hover .partner-logo {
    opacity: 1;
    filter: drop-shadow(0 6px 18px rgba(236, 72, 153, 0.6));
    transform: rotate(-15deg);
}

/* ===============================
   NAME
=============================== */

.partner-name {
    font-size: 1.25rem;
    font-weight: 700;
    color: #ffffff;
    margin: 0;
    position: relative;
    z-index: 2;
    transition: all 0.3s ease;
    text-shadow: 0 2px 10px rgba(0, 0, 0, 0.3);
}

.partner-card:hover .partner-name {
    background: linear-gradient(135deg, #818cf8, #c084fc);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
}

/* ===============================
   SHINE EFFECT
=============================== */

.card-shine {
    position: absolute;
    top: -50%;
    left: -50%;
    width: 200%;
    height: 200%;
    background: linear-gradient(45deg, 
        transparent 30%,
        rgba(255, 255, 255, 0.2) 50%,
        transparent 70%
    );
    transform: rotate(45deg);
    opacity: 0;
    transition: all 0.8s ease;
    z-index: 1;
    pointer-events: none;
}

.partner-card:hover .card-shine {
    opacity: 1;
    animation: shimmerPass 1.5s ease-out;
}

@keyframes shimmerPass {
    from {
        transform: translateX(-100%) rotate(45deg);
    }
    to {
        transform: translateX(100%) rotate(45deg);
    }
}

/* ===============================
   RESPONSIVE
=============================== */

@media (max-width: 768px) {
    .partners-section {
        padding: 80px 0;
    }

    .section-header {
        margin-bottom: 70px;
    }

    .partners-grid {
        grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
        gap: 28px;
    }

    .partner-card {
        padding: 42px 30px;
    }

    .partner-logo-wrapper {
        width: 110px;
        height: 110px;
    }

    .partner-logo {
        width: 65px;
        height: 65px;
    }

    .partner-name {
        font-size: 1.125rem;
    }
}

@media (max-width: 576px) {
    .partners-grid {
        grid-template-columns: repeat(2, 1fr);
        gap: 24px;
    }

    .partner-card {
        padding: 38px 24px;
    }
}
`, "",{"version":3,"sources":["webpack://./src/components/Partners.css"],"names":[],"mappings":"AAAA;;iCAEiC;;AAEjC;IACI,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;;iCAEiC;;AAEjC;IACI,kBAAkB;IAClB,oBAAoB;IACpB,iCAAiC;AACrC;;AAEA;IACI,qBAAqB;IACrB,iBAAiB;IACjB,oCAAoC;IACpC,yCAAyC;IACzC,mBAAmB;IACnB,gCAAgC;IAChC,mBAAmB;IACnB,gBAAgB;IAChB,mBAAmB;IACnB,yBAAyB;IACzB,sBAAsB;IACtB,8CAA8C;AAClD;;AAEA;IACI,mCAAmC;IACnC,gBAAgB;IAChB,cAAc;IACd,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,8DAA8D;IAC9D,6BAA6B;IAC7B,oCAAoC;IACpC,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;IACnB,gCAAgC;IAChC,gBAAgB;AACpB;;AAEA;IACI;QACI,UAAU;QACV,2BAA2B;IAC/B;IACA;QACI,UAAU;QACV,wBAAwB;IAC5B;AACJ;;AAEA;;iCAEiC;;AAEjC;IACI,aAAa;IACb,2DAA2D;IAC3D,SAAS;IACT,iBAAiB;IACjB,cAAc;AAClB;;AAEA;;iCAEiC;;AAEjC;IACI,kBAAkB;IAClB,uFAAuF;IACvF,yCAAyC;IACzC,kBAAkB;IAClB,kBAAkB;IAClB,kDAAkD;IAClD,eAAe;IACf,gBAAgB;IAChB,sCAAsC;IACtC;;;;;KAKC;AACL;;AAEA,gCAAgC,qBAAqB,EAAE;AACvD,gCAAgC,qBAAqB,EAAE;AACvD,gCAAgC,qBAAqB,EAAE;AACvD,gCAAgC,qBAAqB,EAAE;AACvD,gCAAgC,qBAAqB,EAAE;AACvD,gCAAgC,qBAAqB,EAAE;;AAEvD,2BAA2B;AAC3B;IACI,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,qFAAqF;IACrF,UAAU;IACV,6BAA6B;AACjC;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,wCAAwC;IACxC,qCAAqC;IACrC;;wCAEoC;AACxC;;AAEA;;iCAEiC;;AAEjC;IACI,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,mCAAmC;IACnC,kBAAkB;IAClB,kDAAkD;IAClD,kBAAkB;IAClB,UAAU;IACV,yCAAyC;AAC7C;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,+BAA+B;IAC/B,aAAa;IACb,yBAAyB;AAC7B;;AAEA;IACI,mCAAmC;IACnC,mCAAmC;IACnC,qCAAqC;AACzC;;AAEA;IACI,UAAU;IACV,uDAAuD;IACvD,yBAAyB;AAC7B;;AAEA;;iCAEiC;;AAEjC;IACI,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,SAAS;IACT,kBAAkB;IAClB,UAAU;IACV,yBAAyB;IACzB,0CAA0C;AAC9C;;AAEA;IACI,qDAAqD;IACrD,6BAA6B;IAC7B,oCAAoC;IACpC,qBAAqB;AACzB;;AAEA;;iCAEiC;;AAEjC;IACI,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,WAAW;IACX,YAAY;IACZ;;;;KAIC;IACD,wBAAwB;IACxB,UAAU;IACV,yBAAyB;IACzB,UAAU;IACV,oBAAoB;AACxB;;AAEA;IACI,UAAU;IACV,oCAAoC;AACxC;;AAEA;IACI;QACI,0CAA0C;IAC9C;IACA;QACI,yCAAyC;IAC7C;AACJ;;AAEA;;iCAEiC;;AAEjC;IACI;QACI,eAAe;IACnB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,2DAA2D;QAC3D,SAAS;IACb;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,YAAY;QACZ,aAAa;IACjB;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,mBAAmB;IACvB;AACJ;;AAEA;IACI;QACI,qCAAqC;QACrC,SAAS;IACb;;IAEA;QACI,kBAAkB;IACtB;AACJ","sourcesContent":["/* ===============================\r\n   PREMIUM PARTNERS SECTION - HEXAGONAL LAYOUT\r\n=============================== */\r\n\r\n.partners-section {\r\n    padding: 120px 0;\r\n    position: relative;\r\n    overflow: hidden;\r\n}\r\n\r\n/* ===============================\r\n   SECTION HEADER\r\n=============================== */\r\n\r\n.section-header {\r\n    text-align: center;\r\n    margin-bottom: 100px;\r\n    animation: fadeInUp 0.8s ease-out;\r\n}\r\n\r\n.section-badge {\r\n    display: inline-block;\r\n    padding: 8px 20px;\r\n    background: rgba(99, 102, 241, 0.15);\r\n    border: 1px solid rgba(139, 92, 246, 0.4);\r\n    border-radius: 50px;\r\n    color: rgba(255, 255, 255, 0.95);\r\n    font-size: 0.875rem;\r\n    font-weight: 600;\r\n    margin-bottom: 24px;\r\n    text-transform: uppercase;\r\n    letter-spacing: 0.05em;\r\n    box-shadow: 0 4px 20px rgba(99, 102, 241, 0.2);\r\n}\r\n\r\n.section-title {\r\n    font-size: clamp(2rem, 4vw, 3.5rem);\r\n    font-weight: 700;\r\n    color: #ffffff;\r\n    margin-bottom: 16px;\r\n    letter-spacing: -0.02em;\r\n    line-height: 1.2;\r\n}\r\n\r\n.gradient-text {\r\n    background: linear-gradient(135deg, #818cf8, #c084fc, #f472b6);\r\n    -webkit-background-clip: text;\r\n    -webkit-text-fill-color: transparent;\r\n    background-clip: text;\r\n}\r\n\r\n.section-subtitle {\r\n    font-size: 1.125rem;\r\n    color: rgba(255, 255, 255, 0.75);\r\n    font-weight: 500;\r\n}\r\n\r\n@keyframes fadeInUp {\r\n    from {\r\n        opacity: 0;\r\n        transform: translateY(20px);\r\n    }\r\n    to {\r\n        opacity: 1;\r\n        transform: translateY(0);\r\n    }\r\n}\r\n\r\n/* ===============================\r\n   PARTNERS GRID - HEXAGONAL\r\n=============================== */\r\n\r\n.partners-grid {\r\n    display: grid;\r\n    grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));\r\n    gap: 35px;\r\n    max-width: 1100px;\r\n    margin: 0 auto;\r\n}\r\n\r\n/* ===============================\r\n   PARTNER CARD - HEXAGONAL SHAPE\r\n=============================== */\r\n\r\n.partner-card {\r\n    position: relative;\r\n    background: linear-gradient(135deg, rgba(99, 102, 241, 0.08), rgba(168, 85, 247, 0.05));\r\n    border: 2px solid rgba(139, 92, 246, 0.3);\r\n    padding: 50px 36px;\r\n    text-align: center;\r\n    transition: all 0.5s cubic-bezier(0.16, 1, 0.3, 1);\r\n    cursor: pointer;\r\n    overflow: hidden;\r\n    animation: fadeInUp 0.6s ease-out both;\r\n    clip-path: polygon(\r\n        30% 0%, 70% 0%,\r\n        100% 30%, 100% 70%,\r\n        70% 100%, 30% 100%,\r\n        0% 70%, 0% 30%\r\n    );\r\n}\r\n\r\n.partner-card[data-index=\"0\"] { animation-delay: 0.1s; }\r\n.partner-card[data-index=\"1\"] { animation-delay: 0.2s; }\r\n.partner-card[data-index=\"2\"] { animation-delay: 0.3s; }\r\n.partner-card[data-index=\"3\"] { animation-delay: 0.4s; }\r\n.partner-card[data-index=\"4\"] { animation-delay: 0.5s; }\r\n.partner-card[data-index=\"5\"] { animation-delay: 0.6s; }\r\n\r\n/* Gradient border effect */\r\n.partner-card::before {\r\n    content: '';\r\n    position: absolute;\r\n    inset: 0;\r\n    background: linear-gradient(135deg, rgba(99, 102, 241, 0.3), rgba(168, 85, 247, 0.2));\r\n    opacity: 0;\r\n    transition: opacity 0.5s ease;\r\n}\r\n\r\n.partner-card:hover::before {\r\n    opacity: 1;\r\n}\r\n\r\n.partner-card:hover {\r\n    transform: translateY(-12px) scale(1.05);\r\n    border-color: rgba(168, 85, 247, 0.6);\r\n    box-shadow: \r\n        0 25px 60px rgba(99, 102, 241, 0.4),\r\n        0 0 60px rgba(168, 85, 247, 0.3);\r\n}\r\n\r\n/* ===============================\r\n   LOGO\r\n=============================== */\r\n\r\n.partner-logo-wrapper {\r\n    width: 130px;\r\n    height: 130px;\r\n    margin: 0 auto 28px;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    background: rgba(99, 102, 241, 0.1);\r\n    border-radius: 50%;\r\n    transition: all 0.5s cubic-bezier(0.16, 1, 0.3, 1);\r\n    position: relative;\r\n    z-index: 2;\r\n    border: 2px solid rgba(139, 92, 246, 0.3);\r\n}\r\n\r\n.partner-logo {\r\n    width: 75px;\r\n    height: 75px;\r\n    object-fit: contain;\r\n    filter: brightness(0) invert(1);\r\n    opacity: 0.85;\r\n    transition: all 0.5s ease;\r\n}\r\n\r\n.partner-card:hover .partner-logo-wrapper {\r\n    background: rgba(168, 85, 247, 0.2);\r\n    transform: scale(1.1) rotate(15deg);\r\n    border-color: rgba(168, 85, 247, 0.6);\r\n}\r\n\r\n.partner-card:hover .partner-logo {\r\n    opacity: 1;\r\n    filter: drop-shadow(0 6px 18px rgba(236, 72, 153, 0.6));\r\n    transform: rotate(-15deg);\r\n}\r\n\r\n/* ===============================\r\n   NAME\r\n=============================== */\r\n\r\n.partner-name {\r\n    font-size: 1.25rem;\r\n    font-weight: 700;\r\n    color: #ffffff;\r\n    margin: 0;\r\n    position: relative;\r\n    z-index: 2;\r\n    transition: all 0.3s ease;\r\n    text-shadow: 0 2px 10px rgba(0, 0, 0, 0.3);\r\n}\r\n\r\n.partner-card:hover .partner-name {\r\n    background: linear-gradient(135deg, #818cf8, #c084fc);\r\n    -webkit-background-clip: text;\r\n    -webkit-text-fill-color: transparent;\r\n    background-clip: text;\r\n}\r\n\r\n/* ===============================\r\n   SHINE EFFECT\r\n=============================== */\r\n\r\n.card-shine {\r\n    position: absolute;\r\n    top: -50%;\r\n    left: -50%;\r\n    width: 200%;\r\n    height: 200%;\r\n    background: linear-gradient(45deg, \r\n        transparent 30%,\r\n        rgba(255, 255, 255, 0.2) 50%,\r\n        transparent 70%\r\n    );\r\n    transform: rotate(45deg);\r\n    opacity: 0;\r\n    transition: all 0.8s ease;\r\n    z-index: 1;\r\n    pointer-events: none;\r\n}\r\n\r\n.partner-card:hover .card-shine {\r\n    opacity: 1;\r\n    animation: shimmerPass 1.5s ease-out;\r\n}\r\n\r\n@keyframes shimmerPass {\r\n    from {\r\n        transform: translateX(-100%) rotate(45deg);\r\n    }\r\n    to {\r\n        transform: translateX(100%) rotate(45deg);\r\n    }\r\n}\r\n\r\n/* ===============================\r\n   RESPONSIVE\r\n=============================== */\r\n\r\n@media (max-width: 768px) {\r\n    .partners-section {\r\n        padding: 80px 0;\r\n    }\r\n\r\n    .section-header {\r\n        margin-bottom: 70px;\r\n    }\r\n\r\n    .partners-grid {\r\n        grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\r\n        gap: 28px;\r\n    }\r\n\r\n    .partner-card {\r\n        padding: 42px 30px;\r\n    }\r\n\r\n    .partner-logo-wrapper {\r\n        width: 110px;\r\n        height: 110px;\r\n    }\r\n\r\n    .partner-logo {\r\n        width: 65px;\r\n        height: 65px;\r\n    }\r\n\r\n    .partner-name {\r\n        font-size: 1.125rem;\r\n    }\r\n}\r\n\r\n@media (max-width: 576px) {\r\n    .partners-grid {\r\n        grid-template-columns: repeat(2, 1fr);\r\n        gap: 24px;\r\n    }\r\n\r\n    .partner-card {\r\n        padding: 38px 24px;\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
